module.exports = __webpack_public_path__ + "img/roche.386ad0a0.jpg";